import { render, staticRenderFns } from "./editIcon.vue?vue&type=template&id=47c6fc98&scoped=true"
import script from "./editIcon.vue?vue&type=script&lang=ts"
export * from "./editIcon.vue?vue&type=script&lang=ts"
import style0 from "./editIcon.vue?vue&type=style&index=0&id=47c6fc98&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c6fc98",
  null
  
)

export default component.exports